/* Slider */
var carousel_resize_lock = false;
var scrollPoints = [];
var scrollBlock = false;

/* Load video for screen size */
function setVideoSrc(){
  document.querySelectorAll(".slide.video").forEach(function (slide) {
    const video = slide.querySelector("video");
    let src = video.getAttribute("data-src-desktop");

    let change_src = false;
    const orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
    if (window.innerWidth < 1024 && orientation === "portrait") {
      if (video.getAttribute("data-current-src") !== "mobile") {
        change_src = true;
      }
      src = video.getAttribute("data-src-mobile");
      video.setAttribute("data-current-src", "mobile");
    }else{
      if (video.getAttribute("data-current-src") !== "desktop") {
        change_src = true;
      }
      src = video.getAttribute("data-src-desktop");
      video.setAttribute("data-current-src", "desktop");
    }

    if (change_src) {
      video.innerHTML = '';
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
    }
  })
}
setVideoSrc();
window.addEventListener('resize', setVideoSrc);

$("document").ready(function(){
    /* Navigation */
    $(".navigation--toggle").click(function(){
        $(this).parents(".top-navigation").toggleClass("open");
        $("body").toggleClass("navigation-open");
    });
    /*if($(window).width() < 993){
      $(".top-navigation .menu-item-has-children").click(function(e){
        e.preventDefault();
        $(this).find(".sub-menu").slideToggle();
      });
    }*/
    $(".navigation li.page_item_has_children > a > .open-dropdown").click(function(e){
        if($(window).width() > 992 && $(window).width() > $(window).height()) {
            return true;
        }
        e.preventDefault();
        $(this).parents("a").next(".children").slideToggle();
        $(this).toggleClass("open");
    });
    /* Navigation Mobile Effects */
    var i = 0.4;
    var transition_delay_css = "-webkit-transition-delay: duration;-moz-transition-delay: duration;-ms-transition-delay: duration;-o-transition-delay: duration;transition-delay: duration;";
    $(".navigation .menu > ul > li.page_item").each(function(){
        var item_delay = transition_delay_css.replace(/duration/g,i+"s");
        $(this).attr("style",item_delay);
        i += 0.1;
    });
    var item_delay = transition_delay_css.replace(/duration/g,i+"s");
    $(".navigation .language-navigation ul").attr("style",item_delay);

    $(".owl-carousel").each(function(){
      var autoplay = ($(this).find(".slide").first().hasClass("video-autoplay") ? false : true);
      var autoplayTimeout = $(this).attr("data-slide-transition-time");
      $(this).owlCarousel({
        "items": 1,
        "loop": true,
        "autoplay": autoplay,
        "autoplayTimeout": autoplayTimeout
      });
    });
    $(".owl-carousel").on('translate.owl.carousel', function(event) {
      if(event.target.querySelectorAll(".video-autoplay").length == 0){
        $(this).find(".playing").removeClass("playing");
        $(this).find("video").trigger("pause");
        $(this).find(".slide--play-overlay").removeClass("invisible");
      }
    });
    $(".slide--play-overlay").click(function(){
        var parent = $(this).parents(".slide");
        var video = parent.find("video");
        parent.toggleClass("playing");
        $(this).toggleClass("invisible");

        if (video.prop('paused')){
          video.trigger('play');
          parent.find(".slide--content.slide--content--overlay").addClass("invisible");
          parent.find("img").addClass("invisible");
          $(this).closest(".owl-carousel").trigger('stop.owl.autoplay');
        }else{
          video.trigger('pause');
          $(this).closest(".owl-carousel").trigger('play.owl.autoplay');
        }
    });
    $(".slide.video .slide--content").click(function(){
      var parent = $(this).parents(".slide");
      var video = parent.find("video");
      if (video.prop('paused')) {
        video.trigger('play');
      } else {
        video.trigger('pause');
      }
    });
    $(".slider .btn").click(function (e) {
      e.stopPropagation();
    });
    $(".slider .arrow").click(function(e){
      e.stopPropagation();
      scrollBlock = true;

      const parent = $(this).parents(".slider");
      let offset_top = 0;
      if(parent.next(".module").length > 0){
        offset_top = parent.next(".module").offset().top - $(".top-navigation").outerHeight();
      }else{
        offset_top = parent.offset().top - $(".top-navigation").outerHeight() + 500;
      }

      $('html, body').stop().animate({
        'scrollTop': offset_top
      }, 300, 'swing', function () {
        scrollBlock = false;
      });
    });

    if($(".sidebar-nav-menu").length > 0){
      window.setTimeout(function(){
        $(".sidebar-nav-menu").removeClass("active");
      }, 5000);
    }

    /* Quote Images */
    //Set position of dots at bottom of image - only for mobile portrait
    if($(window).width() < 992 && $(window).width() < $(window).height()){
        var img_height = $(".quote-images img").height();
        $(".quote-images .owl-dots").css("top", img_height-parseInt($(".quote-images .owl-dots").css("bottom"))-5);
        $(".quote-images .owl-dots").css("bottom", "auto");
    }

    /*window.sr = ScrollReveal();
    sr.reveal('.module .reveal', {reset: true});
    sr.reveal('.module .reveal-sequence', 250);*/

    var controller = new ScrollMagic.Controller({globalSceneOptions: {

    }});

    var modules = document.querySelectorAll(".module");
    for(var i = 0; i < modules.length; i++){
        new ScrollMagic.Scene({
            triggerElement: modules[i],
            triggerHook: "onEnter",
            offset: "200"
        })
            .setClassToggle(modules[i], "scroll-active")
            //.addIndicators()
            .addTo(controller);
    }

    $(".accordion--toggle").click(function(e){
        e.preventDefault();
        e.stopPropagation();
        var target = $(this).attr("data-target");
        var parent = $(this).parents(".accordion");
        var target_element = parent.find("#"+target);
        var target_element_body = parent.find("#accordion-entry-body-"+target);
        if(target_element.hasClass("open")){
            target_element.removeClass("open")
            target_element_body.slideUp('fast');
            history.pushState("", document.title, window.location.pathname + window.location.search);
        }else{
            history.pushState({}, '', "#"+target);
            if(parent.find(".accordion--entry.open").length > 0){
                parent.find(".accordion--entry.open").find(".accordion--entry--body").slideUp('fast');
                parent.find(".accordion--entry.open").removeClass("open");
                parent.find("#"+target).addClass("open");
                parent.find("#accordion-entry-body-"+target).slideDown('fast');
            }else{
                parent.find("#"+target).addClass("open");
                parent.find("#accordion-entry-body-"+target).slideDown('fast');
            }
        }
    });

    if(window.location.hash !== ""){
        openAccordion(window.location.hash);
    }

    $(".teaser-row .btn").click(function(e){
      scrollBlock = true;
      e.preventDefault();
      e.stopPropagation();

      if(this.hash){
        openAccordion(this.hash);
      }
    });

    function openAccordion(hash){
      var target = hash;
        target = target.replace("#", "");

        var target_element = $("#"+target);
        if(!target_element.hasClass("accordion--entry")){
          return false;
        }
        var parent = target_element.parents(".accordion");
        var target_element_body = parent.find("#accordion-entry-body-"+target);
        if(target_element.hasClass("open")){
            target_element.removeClass("open")
            target_element_body.slideUp('fast');
        }else{
            if(parent.find(".accordion--entry.open").length > 0){
                parent.find(".accordion--entry.open").find(".accordion--entry--body").slideUp('fast');
                parent.find(".accordion--entry.open").removeClass("open");
                parent.find("#"+target).addClass("open");
                parent.find("#accordion-entry-body-"+target).slideDown('fast');
            }else{
                parent.find("#"+target).addClass("open");
                parent.find("#accordion-entry-body-"+target).slideDown('fast');
            }
        }

        $('html, body').stop().animate({
          'scrollTop': parent.offset().top-$(".top-navigation").height()
        }, 900, 'swing', function () {
          scrollBlock = false;
        });
    }

    function closeAccordion(target){
      $(".accordion--entry.open").each(function(){
        $(this).find(".accordion--entry--body").slideUp()
        $(this).removeClass("open");
        $('html, body').stop().animate({
          'scrollTop': $(target).offset().top - $(".top-navigation").height() + 1
        }, 900, 'swing');
      });
    }

  $(".teaser.teaser--video").click(function(){
    var video = $(this).find("video");
    $(this).toggleClass("playing");
    video.trigger( video.prop('paused') ? 'play' : 'pause');
  });
  $("video").bind("ended",function(){
    var parent = $(this).parents(".video-parent");
    parent.removeClass("playing");
    var carousel = $(this).closest(".owl-carousel");
    if (carousel.length > 0){
      carousel.trigger('play.owl.autoplay');
    }
  });

  $(".popup .close").click(function(){
    $(this).parents(".popup").fadeOut(function(){
      $(this).remove();
    });
  });

  $('a[href*="#"]').on('click',function(e) {
    if(!scrollBlock){
      if($(this).parents(".accordion").length > 0){
        e.preventDefault();
        closeAccordion(this.hash);
        return true;
      }
      var target = this.hash;
      var $target = $(target);
      if($target.length > 0){
        e.preventDefault();
        scrollBlock = true;
        $(this).parents("ul").find("li").removeClass("current_page_item");
        $(this).parent("li").addClass("current_page_item");
        $('html, body').stop().animate({
          'scrollTop': $target.offset().top-$(".top-navigation").height()
        }, 900, 'swing', function () {
          history.pushState(null,null,target);
          scrollBlock = false;
        });
      }
    }
  });

  /* Form */
  $(".wpcf7-form .form-row .form-label-transform input, .wpcf7-form .form-row .form-label-transform textarea").on("focus", function(){
    $(this).parents(".form-label-transform").addClass("active");
  });
  $(".wpcf7-form .form-row .form-label-transform input, .wpcf7-form .form-row .form-label-transform textarea").on("focusout", function(){
    if($(this).val() == ""){
      $(this).parents(".form-label-transform").removeClass("active");
    }
  });
  $(".wpcf7-form .form-row .form-select select").on("change", function(){
    if($(this).val() !== ""){
      $(this).parents(".form-select").addClass("active");
    }else{
      $(this).parents(".form-select").removeClass("active");
    }
  });
  $(".wpcf7-form .form-row input[type='file']").on("change", function(){
    $(this).parent("div").find(".file-list").remove();
    const filename = $(this).val().split('\\').pop();
    let html = '<span class="file-list">'+filename+'</span>';
    $(html).insertAfter($(this).parents(".form-file").find(".file-label"));
  });

  $(".accordion--entry--body--inner img").each(function(){
    $(this).wrap('<div class="img-zoom-container"></div>');
    $('<div class="img-zoom-result"></div>').insertAfter($(this));
    imageZoom(this);
  });
  $(".module.accordion .accordion--entry .accordion--entry--body .accordion--entry--body--inner p:last-of-type").append('<div class="contact-tile"><div class="contact-tile__inner"><div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></div><div class="contact-tile__headline">Interesse geweckt?</div><div class="contact-tile__text">Nehmen Sie jetzt Kontakt zu unseren Tresor-Experten auf und lassen Sie sich Ihren persönlichen Tresor erstellen.</div><div class="contact-tile__cta"><button type="button" class="btn btn-rounded btn-primary contact-button-overlay">Kontakt aufnehmen</button></div></div></div>');

  /* Image Zoom */
  $(".module.accordion .accordion--entry--body .img-zoom-container").click(function(){
    var srcset = $(this).find("img").attr("srcset");
    let src = $(this).find("img").attr("src");
    const split = srcset.split(",");
    if(split.length > 0){
      src = split[split.length - 1].split(" ")[1];
    }

    var alt = $(this).attr("alt");

    var html = '<div class="image-zoom"><div class="image-zoom-inner container"><img src="'+src+'" alt="'+alt+'"><div class="close"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" fill="currentColor" width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm0 7.425 2.717-2.718c.146-.146.339-.219.531-.219.404 0 .75.325.75.75 0 .193-.073.384-.219.531l-2.717 2.717 2.727 2.728c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.384-.073-.53-.219l-2.729-2.728-2.728 2.728c-.146.146-.338.219-.53.219-.401 0-.751-.323-.751-.75 0-.192.073-.384.22-.531l2.728-2.728-2.722-2.722c-.146-.147-.219-.338-.219-.531 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" fill-rule="nonzero"/></svg></div></div></div>';
    $("body").append(html);
    $(".image-zoom .close, .image-zoom").click(function(){
      $(".image-zoom").removeClass("open");
      window.setTimeout(function(){
        $(".image-zoom").remove();
      }, 350);
    });
    $(".image-zoom .image-zoom-inner").click(function(e){
      e.stopPropagation();
    });
    window.setTimeout(function(){
      $(".image-zoom").addClass("open");
    }, 10);
  });
  $('select[name="contact_type"]').change(function(){
    if($(this).val() == "Telefonisch"){
      $('select[name="contact_time"]').closest("label").show();
      $('input[name="phone"]').attr("required", true);
      $('#phone-asterisk').text("*")
    }else{
      $('select[name="contact_time"]').closest("label").hide();
      $('select[name="contact_time"]').val($('select[name="contact_time"] option:first').val());
      $('input[name="phone"]').attr("required", false);
      $('#phone-asterisk').text("")
    }
  });
  $("form.wpcf7-form .wpcf7-validates-as-required").prop("required", true);
  $("form.wpcf7-form").removeAttr("novalidate");
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    setTimeout(function(){
      $(".overlay").removeClass("open");
    }, 3000);
  }, false );

  $(".contact-button-overlay").click(function(){
    $(".overlay").toggleClass("open");
    /*$.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: 'html',
      data: {
        action: "load_contact_form",
        nonce: nonce
      },
    })
    .done(function( data ) {
      $("body").append(data);
    })*/
  });
  $(".overlay .overlay-close").click(function(){
    $(".overlay").removeClass("open");
  });
  if($(".speech-bubble").length){
    let timeout = window.setTimeout(function(){
      $(".speech-bubble").addClass("scale");
      var audio = new Audio(themeurl+'/assets/media/message-notification.mp3');
      audio.play();
    }, 5000);

    $(".speech-bubble").on('mouseenter',function(){
      window.clearTimeout(timeout);
      $(".speech-bubble").addClass("scale");
    });
  }
});

$(window).on('load', function(){
  //scrollspy
  $('.top-navigation a[href*="#"]').each(function(){
    var $target = $(this.hash);
    if($target.length > 0) {
      scrollPoints.push({
        top: $target.offset().top - $(".top-navigation").height() - 1,
        bottom: $target.offset().top - $(".top-navigation").height() + $target.height() + 1,
        element: $(this).parent("li")
      })
    }
  });
  $(window).scroll(scrollspy);
  function scrollspy(){
    var scrollTop = $(window).scrollTop();
    navigationScrollSwitch(scrollTop);
    if(!scrollBlock){
      for(var i = 0; i < scrollPoints.length; i++){
        if(scrollTop >= scrollPoints[i].top && scrollTop <= scrollPoints[i].bottom){
          scrollPoints[i].element.addClass("current_page_item");
        }else{
          scrollPoints[i].element.removeClass("current_page_item");
        }
      }
    }
  }

  function navigationScrollSwitch(scrollTop){
    if($(".top-navigation.navigation--scroll-switch").length > 0){
      if(scrollTop > $(window).height()/2){
        $(".top-navigation").addClass("scrolled");
      }else{
        $(".top-navigation").removeClass("scrolled");
      }
    }
  }
  navigationScrollSwitch($(window).scrollTop());

  if(window.location.hash){
    var target = window.location.hash;
    var $target = $(target);
    if($target.length > 0) {
      scrollBlock = true;
      $('a[href*="'+window.location.hash+'"]').parent("li").addClass("current_page_item");
      $('html, body').stop().animate({
        'scrollTop': $target.offset().top-$(".top-navigation").height() + 1
      }, 900, 'swing', function () {
        history.pushState(null,null,target);
        scrollBlock = false;
      });
    }
  }
});

$(window).resize(function() {
    carousel_resize_lock = true;
    if($(window).width() > 992 && $(window).width() > $(window).height()) {
        $(".quote-images .owl-dots").removeAttr("style");
    }
});

function imageZoom(imgObj) {
  const windowWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  if(windowWidth < 1024){
    return false;
  }
  var img, lens, result, cx, cy;
  img = imgObj;
  result = imgObj.nextSibling;
  /* Create lens: */
  lens = document.createElement("DIV");
  lens.setAttribute("class", "img-zoom-lens");
  /* Insert lens: */
  img.parentElement.insertBefore(lens, img);
  const resultWidth = parseInt(getComputedStyle(result).width,10);
  const resultHeight = parseInt(getComputedStyle(result).height,10);
  const lensWidth = parseInt(getComputedStyle(lens).width,10);
  const lensHeight = parseInt(getComputedStyle(lens).height,10);
  /* Calculate the ratio between result DIV and lens: */
  cx = resultWidth / lensWidth;
  cy = resultHeight / lensHeight;
  /* Set background properties for the result DIV */
  let highestImageSrc;
  if(typeof img.srcset !== "undefined"){
    highestImageSrc = img.srcset.split(",")[img.srcset.split(",").length - 1].trim().split(" ")[0];
  }else{
    highestImageSrc = img.src;
  }
  result.style.backgroundImage = "url('" + highestImageSrc + "')";
  result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
  /* Execute a function when someone moves the cursor over the image, or the lens: */
  img.parentElement.addEventListener("mouseenter", enterLens);
  img.parentElement.addEventListener("mouseleave", leaveLens);
  lens.addEventListener("mousemove", moveLens);
  img.addEventListener("mousemove", moveLens);
  /* And also for touch screens: */
  lens.addEventListener("touchmove", moveLens);
  img.addEventListener("touchmove", moveLens);
  function enterLens() {
    img.parentElement.classList.add("active");
    if(result.getBoundingClientRect().x > windowWidth / 2){
      result.classList.add("left");
    }
  }
  function leaveLens() {
    img.parentElement.classList.remove("active");
  }
  function moveLens(e) {
    var pos, x, y;
    /* Prevent any other actions that may occur when moving over the image */
    e.preventDefault();
    /* Get the cursor's x and y positions: */
    pos = getCursorPos(e);
    /* Calculate the position of the lens: */
    x = pos.x - (lens.offsetWidth / 2);
    y = pos.y - (lens.offsetHeight / 2);
    /* Prevent the lens from being positioned outside the image: */
    if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
    if (x < 0) {x = 0;}
    if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
    if (y < 0) {y = 0;}
    /* Set the position of the lens: */
    lens.style.left = x + "px";
    lens.style.top = y + "px";
    /* Display what the lens "sees": */
    result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
  }
  function getCursorPos(e) {
    var a, x = 0, y = 0;
    e = e || window.event;
    /* Get the x and y positions of the image: */
    a = img.getBoundingClientRect();
    /* Calculate the cursor's x and y coordinates, relative to the image: */
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /* Consider any page scrolling: */
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x : x, y : y};
  }
}